var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.21979 6.76152L11.1808 2.21237L11.1808 10.5756L6.51329 13.2428L2.58997 15.4847L2.58997 7.84683C2.58997 7.39826 2.83032 6.98408 3.21979 6.76152ZM7.2575 14.5451L11.9308 11.8746L14.5397 13.3654L17.6853 15.1629L20.51 16.777L12.551 21.325C12.1667 21.5446 11.6949 21.5446 11.3106 21.325L3.35164 16.777L7.2575 14.5451ZM21.2717 7.84683L21.2717 15.4847L18.4295 13.8606L15.2839 12.0631L12.6808 10.5756L12.6808 2.21237L20.6418 6.76152C21.0313 6.98408 21.2717 7.39826 21.2717 7.84683Z",
    stroke: "#2D2D2D",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3728 11.7311L8.32741 14.6142L3.28198 17.4973",
    stroke: "#2D2D2D",
    strokeWidth: 0.142708
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8138 12.4533L9.76833 15.3364L4.7229 18.2195",
    stroke: "#2D2D2D",
    strokeWidth: 0.142708
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.169 13.231L11.2101 16.0564L6.16467 18.9395",
    stroke: "#2D2D2D",
    strokeWidth: 0.142708
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60596 19.6608L12.6514 16.7777L15.1741 15.3361L16.4355 14.6153L17.0661 14.255L17.3815 14.0748",
    stroke: "#2D2D2D",
    strokeWidth: 0.142708
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90356 20.4963L14.0932 17.4979L16.6159 16.0563L17.8772 15.3356L18.5079 14.9752L18.8232 14.795",
    stroke: "#2D2D2D",
    strokeWidth: 0.142708
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3163 21.3038L15.5347 18.2189L18.0574 16.7774L19.3187 16.0566L19.9494 15.6962",
    stroke: "#2D2D2D",
    strokeWidth: 0.142708
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5797 11.7311L15.6251 14.6142L20.6705 17.4973",
    stroke: "#2D2D2D",
    strokeWidth: 0.142708
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.13754 12.4533L14.183 15.3364L19.2284 18.2195",
    stroke: "#2D2D2D",
    strokeWidth: 0.142708
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.69687 13.1735L12.7423 16.0566L17.7877 18.9397",
    stroke: "#2D2D2D",
    strokeWidth: 0.142708
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3457 19.6608L11.3003 16.7777L8.77756 15.3361L7.51621 14.6153L6.88553 14.255L6.57019 14.0748",
    stroke: "#2D2D2D",
    strokeWidth: 0.142708
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1598 20.4963L9.85845 17.4979L7.33573 16.0563L6.07438 15.3356L5.4437 14.9752L5.12836 14.795",
    stroke: "#2D2D2D",
    strokeWidth: 0.142708
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7472 21.3038L8.41707 18.2189L5.89436 16.7774L4.633 16.0566L4.00233 15.6962",
    stroke: "#2D2D2D",
    strokeWidth: 0.142708
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8538 14.3332V9.73321L15.0938 8.35321V12.9532",
    stroke: "#2D2D2D",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoom);
export default __webpack_public_path__ + "static/media/room.19df54c243c93a58966386e0954be044.svg";
export { ForwardRef as ReactComponent };